import React from 'react';
import { gameRequests } from '../../request/requests';
import ResponseEditor from './ResponseEditor';

export default function QuestionEditor({question, loadQuestions}){

    const [questionTitle, setQuestionTitle] = React.useState(question.title);
    const [questionCity, setQuestionCity] = React.useState(question.city);
    const [questionTip, setQuestionTip] = React.useState(question.tip);
    console.log(question)
    const [newReponses, setNewReponses] = React.useState([]);

    return (
        <div style={{border: '1px solid black', padding: '10px', marginTop: '10px'}}>
            <label>Title</label><br />
            <input type="text" value={questionTitle} onChange={(e)=>{setQuestionTitle(e.target.value)}} /><br />
            <label>City</label><br />
            <input type="text" value={questionCity} onChange={(e)=>{setQuestionCity(e.target.value)}} /><br />
            <label>Tip</label><br />
            <input type="text" value={questionTip} onChange={(e)=>{setQuestionTip(e.target.value)}} /><br />
            <button onClick={()=>{gameRequests.updateQuestion(question.id, questionTitle, questionCity, questionTip);}}>
                Modifier
            </button>
            <button style={{color: 'red'}} onClick={()=>{gameRequests.deleteQuestion(question.id); loadQuestions();}}>
                Supprimer
            </button>
            
            <br />
            <label style={{padding: '10px'}}>Answers</label><br />
            <ul style={{padding: '0 10px'}}>
                {
                    question.responses.map((response, index) => {
                        return (
                            <ResponseEditor loadQuestions={loadQuestions} response={response} key={index}/>
                        );
                    })
                }
            </ul>
            <br />
            <div style={{padding: '20px', marginTop: '-40px'}}>
                <input type="text" value={newReponses} onChange={(e)=>{setNewReponses(e.target.value)}} />
                <button onClick={()=>{gameRequests.createResponse(question.id, newReponses); loadQuestions(); setNewReponses('');}}>
                    Ajouter réponse
                </button>
            </div>
        </div>
    );
}